<div class="template-preloading">
  <ng-lottie [options]="options"></ng-lottie>
  <p>
    Mohon Tunggu<br/>
    Bentar ya Sohib~
  </p>
</div>